import React, { Component } from "react";
import DetailContent from "../components/detail_content";
import Slider from "../components/slider";
import firebase from "../config/firebaseInit";

function calcCrow(lat1, lon1, lat2, lon2) {
    let R = 6371; // km
    let dLat = toRad(lat2 - lat1);
    let dLon = toRad(lon2 - lon1);
    lat1 = toRad(lat1);
    lat2 = toRad(lat2);

    let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let d = R * c;
    return d;
}

function toRad(Value) {
    return Value * Math.PI / 180;
}


class Detail extends Component {
    constructor(props) {
        super(props);
        this.state = { article: {} };
    }

    componentDidMount() {
        try {
            let lat = null;
            let long = null;
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    lat = position.coords.latitude;
                    long = position.coords.longitude;
                }, function () { });
            }
            let db = firebase.firestore();
            let data = {};
            db.collection("lieux").where("designation", "==", this.props.match.params.id).get().then((snapshot) => {
                snapshot.forEach((doc) => {
                    data = doc.data();
                    let distance = calcCrow(lat, long, data.position.latitude
                        , data.position.longitude).toFixed(1);
                    if (distance < 1) {
                        data.distance = (distance * 1000) + " m";
                    } else {
                        data.distance = (distance) + " km";
                    }
                })
                this.setState({ article: data });

            });


        } catch (error) {

        }

    }

    render() {
        return (
            <React.Fragment>
                <Slider article={this.state.article} />
                <DetailContent article={this.state.article} />
            </React.Fragment>
        );
    }
}
export default Detail;
